export const { API_URL } = window.appEnvironment || {};
